import React from 'react';
import './index.css';
import App from './App';
import AuthProvider from './components/auth/AuthContext';
import OneOffAuthProvider from './components/oneOffAuth/OneOffAuthContext';
import Keycloak from 'keycloak-js';
import { BrowserRouter as Router } from 'react-router-dom';
import { createInstance, MatomoProvider } from '@datapunt/matomo-tracker-react';
import { getConfig } from './Config';
import { createRoot } from 'react-dom/client';
import {updateSession} from "./axios_interceptors";

const setUpApp = async () => {
  let keycloakConfig;
  if (window.ENV === 'Drone') {
    keycloakConfig = '/config/keycloak_drone.json';
  } else {
    keycloakConfig = '/config/keycloak.json';
  }
  const keycloak = new Keycloak(keycloakConfig);
  const matomoSiteId = getConfig().matomoSiteId;
  const matomoUrl = getConfig().matomoUrl;

  const instance = createInstance(
    {
      urlBase: matomoUrl,
      siteId: matomoSiteId,
      trackerUrl: `${matomoUrl}/matomo.php`,
      srcUrl: `${matomoUrl}/matomo.js`,
      disabled: false,
      heartBeat: {
        active: true,
        seconds: 10,
      },
      linkTracking: false,
      configurations: {
        disableCookies: true,
        setSecureCookie: true,
        setRequestMethod: 'POST',
      },
    },
    [matomoSiteId, matomoUrl]
  );

  const main = () => {
    const root = createRoot(document.getElementById('root'));
    const token = sessionStorage.getItem('token');
    const refreshToken = sessionStorage.getItem('refreshToken'); // this is used only in Cypress tests

    const renderApp = () => {
      root.render(
        <MatomoProvider value={instance}>
          <AuthProvider keycloak={keycloak}>
            <OneOffAuthProvider>
              <Router>
                <App keycloak={keycloak} />
              </Router>
            </OneOffAuthProvider>
          </AuthProvider>
        </MatomoProvider>
      );
    };
    keycloak
      .init({
        flow: 'hybrid',
        checkLoginIframe: false,
        redirectUri: window.location,
        onLoad: 'check-sso',
        token,
        refreshToken,
      })
      .then(() => {
        updateSession(keycloak);
        renderApp();
      })
      .catch(() => {
        sessionStorage.setItem('authenticated', 'false');
        renderApp();
      });
  };
  main();
};

await setUpApp();
